export const ACTIVE_ORDER_ID = 'merchstore-pending';
